export default class BaseEntityDto {
    id: string;
    createdAt: Date = new Date();
    updatedAt: Date = new Date();
}